import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/use-auth";
import FeedBackByCustomerId from "../../pages/dashboard/FeedBacks/feedBackByCustomerId";
import CustomerDetails from "../../pages/dashboard/customers/[customerId]";

const RoleCustomerDetailsdRedirect = () => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/" />;
  }

  if ((user.roles_id === 1 && user.access_level === 1)|| user.access_level === 1) {
    return <CustomerDetails F_W={true} />;
  } else {
    return <FeedBackByCustomerId />;
  }
};

export default RoleCustomerDetailsdRedirect;
